// extracted by mini-css-extract-plugin
module.exports = {"externalLinkIcon":"_9c4a1d"};